import "../../css/agents.css";
import { Col, Row, Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from "react";
import { connect } from 'react-redux';
import useMonitorAPIService from '../../services/monitorapiservice';
import { abbreviate } from "../utils/utils";
import Agent from "./agent";
import AgentsStatus from "./agentstatus";

function Agents(props) {

    const { t } = useTranslation();
    const [dir, setDir] = useState("asc");
    const [agents, setAgents] = useState([]);
    const [allAgents, setAllAgents] = useState([]);
    const { getSupervisedAgents, reloadAgentData } = useMonitorAPIService();
    const [selectedAgent, setSelectedAgent] = useState(null);
    const [filter, setFilter] = useState(localStorage.getItem("agentsFilter") || "");

    useEffect(() => {

        loadAgents();

        document.addEventListener('reloadAgents', reloadAgent);
        var interval = setInterval(() => {
            loadAgents();
        }, (5000));

        return () => {
            // component unmounts
            document.addEventListener('reloadAgents', reloadAgent);
            localStorage.removeItem("selectedAgentId");
            localStorage.removeItem("agentsFilter");
            clearInterval(interval);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const loadAgents = () => {
        getSupervisedAgents(props.token, updateAgents);

    }

    const updateAgents = (res) => {
        if (res.data != null && res.data.length > 0) {
            var userId = localStorage.getItem("selectedAgentId");
            var selectedAgent = null;
            for (var i in res.data) {
                var v = res.data[i];
                v.initials = abbreviate(v.name);
                if (userId !== null && v.userId === parseInt(userId)) {
                    v.selected = true;
                    selectedAgent = v;
                }

            }

            res.data.sort(sortByStatus);
            let filter = localStorage.getItem("agentsFilter");
            let filteredAgents = res.data;
            let sort = localStorage.getItem("agentsSortDir")

            if (filter !== null && filter !== "")
                filteredAgents = res.data.filter(x => x.name.toLowerCase().indexOf(filter) > -1);

            if (sort === "asc") {
                filteredAgents.sort(function (a, b) {

                    const nameA = a.name.toLowerCase();
                    const nameB = b.name.toLowerCase();

                    if (nameA < nameB) {
                        return -1;
                    } else if (nameA > nameB) {
                        return 1;
                    } else {
                        return 0;
                    }
                });
            } else {
                filteredAgents.sort(function (a, b) {
                    const nameA = a.name.toLowerCase();
                    const nameB = b.name.toLowerCase();

                    if (nameA > nameB) {
                        return -1;
                    } else if (nameA < nameB) {
                        return 1;
                    } else {
                        return 0;
                    }

                });
            }
            filteredAgents.sort(sortByStatus);
            setAgents(filteredAgents);
            setAllAgents(res.data);
            setSelectedAgent(selectedAgent);

        }
    }

    const reloadAgent = () => {
        let agentId = parseInt(localStorage.getItem("selectedAgentId"));
        reloadAgentData(props.token, agentId, (res) => {
            let agent = res.data;
            agent.initials = abbreviate(agent.name);
            agent.selected = false;
            setSelectedAgent(agent);
            setAgents(prevState =>
                prevState.map(a =>
                    a.pin === agent.pin ? { ...agent } : { ...a, selected: false }
                )
            );
            setAllAgents(prevState =>
                prevState.map(a =>
                    a.pin === agent.pin ? { ...agent, selected: true } : { ...a, selected: false }
                )
            );
        });

    }

    const handleChange = (e) => {
        let filter = e.target.value.toLowerCase();
        let filteredAgents = allAgents.filter(x => x.name.toLowerCase().indexOf(filter) > -1);
        setAgents(filteredAgents);
        setFilter(filter);
        localStorage.setItem("agentsFilter", filter);
    }

    const handleSort = (e) => {
        let sort = dir === "asc" ? "desc" : "asc";
        if (sort === "asc") {
            agents.sort(function (a, b) {

                const nameA = a.name.toLowerCase();
                const nameB = b.name.toLowerCase();

                if (nameA < nameB) {
                    return -1;
                } else if (nameA > nameB) {
                    return 1;
                } else {
                    return 0;
                }
            });
        } else {
            agents.sort(function (a, b) {
                const nameA = a.name.toLowerCase();
                const nameB = b.name.toLowerCase();

                if (nameA > nameB) {
                    return -1;
                } else if (nameA < nameB) {
                    return 1;
                } else {
                    return 0;
                }

            });
        }
        agents.sort(sortByStatus);

        setAgents(agents);
        setDir(sort);
        localStorage.setItem("agentsSortDir", sort);
    }

    const sortByStatus = (a, b) => {
        var val1 = a.strAcdStatus,
            val2 = b.strAcdStatus,
            indexA = 0,
            indexB = 0;

        switch (val1) {
            case "Free":
            case "Wrapup":
                indexA = -1
                break;
            case "Paused":
                indexA = -2;
                break;
            case "Unregistered":
                indexA = -3;
                break;
            case "LoggedOut":
                indexA = -4;
                break;
            default:
                indexA = -5;
                break;
        }
        switch (val2) {
            case "Free":
            case "Wrapup":
                indexB = -1;
                break;
            case "Paused":
                indexB = -2;
                break;
            case "Unregistered":
                indexB = -3;
                break;
            case "LoggedOut":
                indexB = -4;
                break;
            default:
                indexB = -5;
                break;
        }

        return indexA > indexB ? -1 : 1;


    }

    const selectAgent = (agent) => {
        setSelectedAgent(agent);
        localStorage.setItem("selectedAgentId", agent.userId);
        setAgents(prevState =>
            prevState.map(a =>
                a.pin === agent.pin ? { ...a, selected: true } : { ...a, selected: false }
            )
        );
        setAllAgents(prevState =>
            prevState.map(a =>
                a.pin === agent.pin ? { ...a, selected: true } : { ...a, selected: false }
            )
        );
    }

    return (
        <Row>
            <Col xs={3}>
                <div className='agents-list'>
                    <Row className='searchagents'>
                        <Col xxl={11} lg={10}>
                            <FontAwesomeIcon className='searchicon' icon={solid("magnifying-glass")} />
                            <Form.Control className='searchinput' value={filter} type="text" placeholder={t("search")} onChange={handleChange}></Form.Control>
                        </Col>
                        <Col xxl={1} lg={2}>
                            <Button variant='light-primary' className='filterbutton' onClick={handleSort}>
                                {
                                    (dir !== "asc") &&
                                    <FontAwesomeIcon icon={solid("arrow-up-wide-short")} />
                                }
                                {
                                    (dir === "asc") &&
                                    <FontAwesomeIcon icon={solid("arrow-down-wide-short")} />
                                }
                            </Button>
                        </Col>
                    </Row>
                    <div className="agents">
                        {
                            agents.map(v => {
                                return <Agent key={v.pin} agent={v} selectAgent={selectAgent}></Agent>
                            })
                        }
                    </div>
                </div>
            </Col>
            <Col xs={9}>
                <div className='agent-settings'>
                    {
                        selectedAgent !== null &&
                        <AgentsStatus agent={selectedAgent}></AgentsStatus>
                    }
                </div>
            </Col>

        </Row>
    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
    };
};

export default connect(mapStateToProps, {})(Agents);